<template>
  <div class="share_wapper">
    <div class="share_header">
      <div class="share_title">
        <div class="title_left">
          <img src="../../../static/img/headicon.jpg" class="share_headimg">
          <div class="title_text">唯真财经</div>
        </div> 
        <div class="title_right">
          <van-button type="danger" size="small" v-clipboard:copy="copyInfo" v-clipboard:success="onCopy" v-clipboard:error="onError">下载</van-button>
        </div>
      </div>
      <div class="live_title">
        <div>
          <van-icon name="video" />
        </div>
        <div class="live_name">
          {{liveInfo.name}}
        </div>
      </div>
    </div>
    <div id='player' style="width:100%;"></div>
    <div class="share_info">
      <div class="info_head">
        <div :class="infoLight == false ? 'info_head_in' : ''" @click="infoLight = false">简介</div>
        <div style="color: #eeeeee;">|</div>
        <div :class="infoLight == true ? 'info_head_in' : ''" @click="infoLight = true">{{course_id == '1' ? '直播' : '视频'}}</div>
      </div>
    </div>
    <div class="info_content">
      <div v-if="infoLight == false && descImg !== ''" @click="seeImg">
        <img :src="descImg" class="desc_img">
      </div>
      <div v-else>
        <van-empty description="下载APP参与聊天" />
      </div>
    </div>
    <div class="share_foot">
      <div class="foot_left">
        <img src="../../../static/img/logo2.png" class="share_headimg">
        <!-- <div>唯真财经</div> -->
      </div>
      <div class="foot_right">
        <van-button v-clipboard:copy="copyInfo" v-clipboard:success="onCopy" v-clipboard:error="onError" type="danger" size="small" style="width: 9rem">下载APP</van-button>
      </div>
    </div>
    <div @click="photoVisible = false">
			<photoSee :seePhoto="seePhoto" :photoVisible.sync="photoVisible"></photoSee>
		</div>
  </div>
</template>
<script>
import photoSee from '../../components/photoSee.vue'
export default {
  data(){
    return {
      liveInfo: {},
      frameUrl: '',
      infoLight: true,
      descImg: '',
      photoVisible: false,
      seePhoto: '',
      copyInfo: this.$route.query.user_id ? this.$route.query.user_id : '',
      course_id: this.$route.query.course_id ? this.$route.query.course_id : '1',
      playerJs: 'https://player.polyv.net/resp/live-h5-player/latest/liveplayer.min.js',
      vodPlayerJs: 'https://player.polyv.net/script/player.js'
    }
  },
  components: { photoSee },
  mounted(){
    this.getLiveOne()
    this.init()
    if(this.copyInfo == ''){
      // alert('user_id为空')
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    async getLiveOne(){
      if(this.course_id == '1'){
      let res = await this.$axios.get("/live/getLiveOne")
        console.log(res);
        if(res.code == 10000 || res.code == 10001){
          this.liveInfo = res.data
          this.descImg = res.data.img_desc_arr.mp
        }
      } else {
        let res = await this.$axios.get('/course/getCourseInfo', {
          params: {
            course_id: this.course_id
          }
        })
        console.log(res);
        if(res.code == 10001 || res.code == 10000){
          this.liveInfo = res.data
          this.descImg = res.data.img_desc_arr.mp
        }
      }
    },
    init(){
      if(this.course_id == '1'){
        this.loadPlayerScript(this.loadPlayer)
      } else {
        // this.loadPlayerScript2(this.loadPlayer2)
      }
    },
    onCopy: function (e) {
      // alert('You just copied: ' + e.text)
      window.location.href = 'https:// wzcjmp.rich0120.com/html/downloadapp.html'
    },
    onError: function (e) {
      // alert('Failed to copy texts')
      window.location.href = 'https:// wzcjmp.rich0120.com/html/downloadapp.html'
    },
    loadPlayerScript(callback) {
      if (!window.polyvLivePlayer) {
        const myScript = document.createElement('script');
        myScript.setAttribute('src', this.playerJs);
        myScript.onload = callback;
        document.body.appendChild(myScript);
      } else {
        callback();
      }
    },
    loadPlayer() {
      const polyvLivePlayer = window.polyvLivePlayer;
      this.player = polyvLivePlayer({
        wrap: '#player',
        height: 200,
        uid: '73b1a21799',
        vid: '2654468',
      });
    },
    loadPlayerScript2(callback) {
      if (!window.polyvPlayer) {
        const myScript = document.createElement('script');
        myScript.setAttribute('src', this.vodPlayerJs);
        myScript.onload = callback;
        document.body.appendChild(myScript);
      } else {
        callback();
      }
    },

    loadPlayer2() {
      const polyvPlayer = window.polyvPlayer;
      this.player = polyvPlayer({
        wrap: '#player',
        height: 200,
        // vid: '73b1a21799bcab84efb59fd0a669c20c_7',
      });
    },
    seeImg(){
      this.seePhoto = this.descImg
      this.photoVisible = true
    },
  }
}
</script>
<style lang="scss" scoped>
  .share_wapper{
    width: 100%;
    height: 100%;
    .share_header{
      padding: 1rem;
      .share_title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title_left{
          display: flex;
          align-items: center;
          .share_headimg{
            width: 30px;
            height: 30px;
          }
          .title_text{
            margin-left: 0.1rem;
            font-weight: bold;
          }
        }
      }
      .live_title{
        display: flex;
        align-items: center;
        margin-top: 1rem;
        .live_name{
          font-size: 14px;
          margin-left: 4px;
        }
      }
    }
    .share_live{
      min-width: 375px;
      width: 100%;
      height: 210px;
      background-color: #000000;
    }
    .share_info{
      display: flex;
      justify-content: center;
      margin-top: 0.75rem;
      .info_head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 7rem;
        font-size: 16px;
        font-weight: bold;
        color: #999999;
        .info_head_in{
          font-size: 18px;
          color: #000000;
        }
      }
    }
    .info_content{
      .desc_img{
        margin-top: 3rem;
        width: 100%;
        min-width: 375px;
        margin-bottom: 52px;
      }
    }
    .share_foot{
      width: 100vw;
      display: flex;
      justify-content: space-between;
      position: fixed;
      bottom: 0;
      padding: 0.5rem;
      box-sizing: border-box;
      background-color: white;
      .foot_left{
        text-align: center;
        .share_headimg{
          width: 6rem;
        }
      }
      .foot_right{
        display: flex;
        align-items: center;
      }
    }
  }
</style>